export function getActivityLogSelector(state) {
    return state.activityLog;
};
